import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AppUrlService } from './app-url.service';
import { SharedStateService } from './shared-state.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
    private tokenKey = 'authToken'; // Key for storing the token in localStorage
    expiresIn!:number;
    constructor(private http: HttpClient, private router: Router,private appUrls : AppUrlService, 
      private sharedService: SharedStateService) {}

    // Method to log in and store the token in localStorage
    login(trackingId: string): Observable<any> {
      return this.http.get(this.appUrls.getURL("login") + trackingId);
    }

    refreshToken(): Observable<any> {
      return this.http.get(this.appUrls.getURL("refreshToken")+this.sharedService.getState("trackingId"));
    }

    // Save token in localStorage
    setToken(token: string): void {
      this.sharedService.changeState(this.tokenKey, token);
    }

    // Get token from localStorage
    getToken(): string | null {
      return this.sharedService.getState(this.tokenKey);
    }

    // Check if the user is logged in
    isAuthenticated(): boolean {
      const token = this.getToken();
      return !!token; // Returns true if the token exists
    }

    // Log out by removing the token
    logout(): void {
      this.sharedService.clearAll();
      this.router.navigate(['/sessionExpired']); // Redirect to login page
    }
  }
